/**
 * ConfigMap K8s : monter `config.js` (window.*) — chargé par public/index.html
 * avant le bundle. Ex. : window.MANIFESTE_MEAD = "https://manifeste-recette.portnet.ma";
 */

const config = {
  // Portail
  crossOrigin: window.CROSS_ORIGIN ?? "*",
  captchaSiteKey:
    window.CAPCTHA_SITE ?? "6LdBG8csAAAAAP9EfOLIiJ76sTABSps_f_4NzonB",

  // APIs (axios)
  authUrl: window.AUTH_API_URL ?? "https://guauth-dev.portnet.ma/",
  achatUrl:
    window.ACHAT_FORFAIT_URL ?? "https://nouvelle-tarificationdev.portnet.ma",
  forfaitUrl:
    window.FORFAIT_URL ?? "https://nouvelle-tarificationdev.portnet.ma",
  tiUrl: window.TI_API_URL ?? "https://titre-importationdev.portnet.ma",
  dfdUrl: window.DFD_API_URL ?? "https://dfd-dev.portnet.ma",
  leUrl: window.LE_API_URL ?? "https://le-dev.portnet.ma",
  refProdUrl:
    window.REFERENTIEL_API_PROD_URL ??
    "https://referentiel-api-prod-v2.portnet.ma",
  refTestUrl:
    window.REFERENTIEL_API_TEST_URL ?? "https://referentiel-api-v2.portnet.ma",
  crcUrl: window.CRC_URL ?? "https://portail-crc-test.portnet.ma",
  paiement: window.PAIEMENT_URL ?? "https://epaiement-dev.portnet.ma",
  epaiement: window.EPAIEMENT ?? "https://epaiement-dev.portnet.ma",

  // MEAD aérien — cœur métier
  manifesteMead: window.MANIFESTE_MEAD ?? "https://manifeste-dev.portnet.ma",
  manifesteAeriens:
    window.MANIFESTE_AERIENS_URL ?? "https://manifeste-dev.portnet.ma",
  dsCombine: window.DS_COMBINE ?? "https://manifeste-dev.portnet.ma",
  badMead: window.BAD_MEAD ?? "https://bad-mead-dev.portnet.ma",
  badDSMead: window.BAD_DS_MEAD ?? "https://bad-ds-combine-dev.portnet.ma",
  terminalBadAerien:
    window.TERMINAL_BAD_AERIEN_URL ?? "https://bad-aerien-dev.portnet.ma",
  badAerien:
    window.BAD_AERIEN ?? "https://bad-dev.portnet.ma/consultation-bad",
  validationBAD:
    window.VALIDATION_BAD ?? "https://edifact-dev.portnet.ma/edifact-upload",
  apurement: window.APUREMENT ?? "https://dum-ml-dev.portnet.ma/listeDum",
  mainLevee: window.MAIN_LEVEE ?? "https://dum-ml-dev.portnet.ma",

  // Avis d'arrivée & manifestes
  avArurl:
    window.AVIS_ARRV_URL ??
    "https://avis-arrivee-fe-test.portnet.ma/arrival-notification",
  consultationAvis:
    window.CONSULTATION_AVIS ??
    "https://avis-arrivee-fe-test.portnet.ma/arrival-notification/consultation",
  manMarImpurl:
    window.MANIFESTE_MAR_IMP_URL ??
    "https://manifeste-maritime-test.portnet.ma",
  manMarExpUrl:
    window.MANIFESTE_MAR_EXP_URL ??
    "https://manifeste-maritime-test.portnet.ma",
  consultationManifesteMaritime:
    window.CONSULTATION_MANIFESTE_MARITIME ??
    "https://manifeste-maritime-test.portnet.ma/list-manifeste-import",
  consultationManifesteExport:
    window.MANIFESTE_EXPORT ??
    "https://manifeste-maritime-test.portnet.ma/list-manifeste-export",
  manifestePassager:
    window.MANIFESTE_PASSAGER ?? "https://manifeste-passager-dev.portnet.ma",
  manifesteDepotage:
    window.MANIFESTE_DEPOTAGE ?? "https://manifeste-maritime-test.portnet.ma",
  etatManifesteBad:
    window.ETAT_MANIFESTE_BAD ?? "https://manifeste-maritime-test.portnet.ma",

  // DAP, navires, mouvements
  urlDAP: window.DAP_URL ?? "https://dap-dev.portnet.ma",
  demandeAttrPostUrl: window.DAP_URL ?? "https://dap-dev.portnet.ma",
  mvmNavireUrl: window.MVM_NAVIRE_URL ?? "https://dap-dev.portnet.ma",
  pgmUrl: window.PGM_URL ?? "https://dap-dev.portnet.ma",
  souscriptionNavires:
    window.SOUSCRIPTION_NAVIRES ?? "https://sn-dev.portnet.ma",

  // Préavis, BAD maritime, booking
  pravisArrive:
    window.PREAVIS_ARRIVEE ?? "https://preavis-arrivee-dev.portnet.ma",
  preavisUrl:
    window.PREAVIS_ARRIVEE_URL ?? "https://preavis-arrivee-dev.portnet.ma",
  badUrl: window.BAD_URL ?? "https://bad-dev.portnet.ma",
  badMaritime: window.BAD_MARITIME ?? "https://bad-dev.portnet.ma",
  badDSAutres: window.BAD_DS_AUTRES ?? "https://bad-ds-autres-dev.portnet.ma",
  booking: window.BOOKING ?? "https://booking-dev.portnet.ma",

  // Douane, DUM, procurations
  dumUrl: window.DUM_URL ?? "https://dum-ml-dev.portnet.ma",
  procurationDouane:
    window.PROCURATION_DOUANE ?? "https://procuration-dev.portnet.ma",
  procurationTransitaire:
    window.PROCURATION_TRANSITAIRE ??
    "https://procuration-transitaire-test.portnet.ma",

  // Séquences, ONICL, EDIFACT, factures
  sequenceUrl:
    window.SEQUENCE_EXPORT_URL ?? "https://sequence-export-test.portnet.ma",
  oniclUrl: window.ONICL_URL ?? "https://onicl-dev.portnet.ma",
  edifact: window.EDIFACT_URL ?? "https://edifact-dev.portnet.ma",
  facturesMarsaMaroc:
    window.FACTURES_MARSA_MAROC ?? "https://epaiement-dev.portnet.ma",

  // Vrac, céréales, reporting
  vracUrl: window.VRAC_URL ?? "https://vrac-test.portnet.ma",
  reportTracUrl:
    window.REPORTING_VRAC_URL ?? "https://reporting-vrac-dev.portnet.ma",
  cerealierUrl: window.CEREALIER_URL ?? "https://cerealier-test.portnet.ma",

  // Visites, KPI, terminal, conteneurs
  visiteCalendrierUrl:
    window.VISITE_CALENDRIER_URL ?? "https://visite-calendrier-test.portnet.ma",
  pkpiDashboardUrl:
    window.PKPI_DASHBOARD_URL ?? "https://pkpi-dev.portnet.ma/dashboard",
  ficheSuiveuseUrl:
    window.FICHE_SUIVEUSE_URL ?? "https://fiche-suiveuse-dev.portnet.ma",
  ficheSuiveuse:
    window.FICHE_SUIVEUSE_URL ?? "https://fiche-suiveuse-dev.portnet.ma",
  ficheSuiv: window.FICHE_SUIVEUSE ?? "/",
  prdvConteneurUrl:
    window.PRDV_CONTENEUR_URL ?? "https://prdv-conteneur-test.portnet.ma",
  rdvImport: window.RDV_IMPORT ?? "https://prdv-conteneur-test.portnet.ma",
  priseRdvVracUrl:
    window.PRISE_RDV_VRAC_URL ?? "https://prise-rdv-vrac-test.portnet.ma",
  pesageUrl: window.PESAGE_URL ?? "https://pesage-dev.portnet.ma",
  bonSortieUrl: window.BON_SORTIE_URL ?? "https://bs-test.portnet.ma",
  bonSortie: window.BON_SORTIE ?? "https://bs-test.portnet.ma",
  terminalEntreeSortie:
    window.TERMINAL_ENTREE_SORTIE ?? "https://terminal-dev.portnet.ma",
  suiviConteneur: window.SUIVI_CONTENEUR ?? "https://conteneur-dev.portnet.ma",
  ics2Ue: window.ICS2_UE ?? "https://ics-dev.portnet.ma",
  showComponent: window.SHOW_COMPONENT ?? false,
  showReclamation: window.SHOW_RECLAMATION ?? false,
  showTijaria: window.SHOW_TIJARIA ?? false,
  baseURL: window.API_URL ?? "http://localhost:8080/api",
  tijariaUrl: window.API_URL_TIJARIA ?? "https://chatbot-dev.portnet.ma",
};

export default config;
